import React, {useState} from 'react';
import SearchDisease from './searchDiseases';
import { Tag, Button, Popconfirm, message  } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useFirestore } from 'reactfire';

const SingleFavAdd = (props) => {

    const firestore = useFirestore();
    const [tags, setTags] = useState(props.currentFav.value.Diagnosis_list || []); 
    const query_fav = firestore.collection('Favourite_Diagnosis');

    const onSelect = (data) => {
        console.log(data);
        setTags([...tags, data]);
    }

    const handleClose = removedTag => {
        const newTags = tags.filter(tag => tag !== removedTag);
        setTags(newTags);
    };

    const addDiagnosisToLIst = id => {
        query_fav.doc(id).update({Diagnosis_list : tags}).then((response) => {
            message.success('List Saved');
            props.listUpdated();
        });
    }


    const confirm = (e) => {
        props.onFavListDelete(props.currentFav.id);
    }


    return (
        <li key={props.currentFav.id}>
            {/* <Skeleton active /> */}
        <Popconfirm
            title="Are you sure to delete this Favorite List?"
            onConfirm={confirm}
            okText="Yes"
            cancelText="No"
        >
            <span className='deleteFavList'><DeleteOutlined /></span>
        </Popconfirm>

            
            <h3>{props.currentFav.value.favourite_list_name}</h3>
            <SearchDisease onSelectProp = {onSelect} />
            <div className='tagsShow'>
                {tags && tags.map((single) => {
                    return<Tag color="#108ee9" closable key={Math.random()} style={{fontSize: '16px', padding: '6px 12px', display: 'inline-flex', alignItems: 'center'}}
                    onClose={e => {
                        e.preventDefault();
                        handleClose(single);
                    }}>{single}</Tag>
                })}
            </div>
            <Button type="primary" className='savFavList' onClick={() => addDiagnosisToLIst(props.currentFav.id)}>Save</Button>
        </li>
    );
}

export default SingleFavAdd;
